import { render, staticRenderFns } from "./parkingSpace.vue?vue&type=template&id=5a978710&scoped=true"
import script from "./parkingSpace.vue?vue&type=script&lang=js"
export * from "./parkingSpace.vue?vue&type=script&lang=js"
import style0 from "./parkingSpace.vue?vue&type=style&index=0&id=5a978710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a978710",
  null
  
)

export default component.exports